import { render, staticRenderFns } from "./PrintBehaviorEditor.vue?vue&type=template&id=db5ea05c&scoped=true&"
import script from "./PrintBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./PrintBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5ea05c",
  null
  
)

export default component.exports